import { rebind } from "../utils";

import { pointAndFigure } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "PointAndFigure";

export default function () {
  const base = baseIndicator().type(ALGORITHM_TYPE);

  const underlyingAlgorithm = pointAndFigure();

  const indicator = underlyingAlgorithm;

  rebind(indicator, base, "id", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "dateAccessor", "dateMutator");
  rebind(indicator, underlyingAlgorithm, "options");
  // rebind(indicator, mergedAlgorithm, "merge"/*, "skipUndefined"*/);

  return indicator;
}
